import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import {
  backgroundColor,
  mq,
  paddingTop,
} from '@sleepstation/style-api-helpers'
import { constrainNarrow, constrainWide } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Border from '../../../Border'
import HeroProductShot from '../../../HeroProductShot'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  ${backgroundColor(`backgroundStart`)}
  ${paddingTop([1.5, 2, 1])}
  margin-left: -1px;
  margin-right: -1px;
  width: calc(100% + 2px);
`

const Inner = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  align: LAYOUT_ALIGN.STRETCH,
})`
  flex: 0 0 auto;
  position: relative;
  z-index: 999;
  ${constrainNarrow()}

  ${mq(`mediumUp`)} {
    ${constrainWide()}
  }
`

const FooterImageWrapper = styled.div`
  ${mq(`mediumUp`)} {
    display: none;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Footer = ({ productShot }) => (
  <Layout>
    <Inner>
      <FooterImageWrapper>
        <HeroProductShot image={productShot} />
      </FooterImageWrapper>
    </Inner>
    <Border isHeader color="backgroundStart" />
  </Layout>
)

Footer.propTypes = {
  productShot: PropTypes.object.isRequired,
}

export default Footer
